import type { RankingRow } from "../types/ranking";

export const mockRanking: RankingRow[] = [
    {
        id: 1,
        position: 1,
        teamName: "Camerlux",
        teamLogo: "/images/teams/camerlux.png",
        points: 22,
        played: 8,
        won: 7,
        drawn: 1,
        lost: 0,
        goalsFor: 18,
        goalsAgainst: 5,
    },
    {
        id: 2,
        position: 2,
        teamName: "CSGL",
        teamLogo: "/images/teams/csgl.png",
        points: 19,
        played: 8,
        won: 6,
        drawn: 1,
        lost: 1,
        goalsFor: 15,
        goalsAgainst: 6,
    },
    {
        id: 3,
        position: 3,
        teamName: "Lions Ind.",
        teamLogo: "/images/teams/lions-ind.png",
        points: 16,
        played: 8,
        won: 5,
        drawn: 1,
        lost: 2,
        goalsFor: 14,
        goalsAgainst: 8,
    },
    {
        id: 4,
        position: 4,
        teamName: "Sénégal",
        teamLogo: "/images/teams/senegal.png",
        points: 13,
        played: 8,
        won: 4,
        drawn: 1,
        lost: 3,
        goalsFor: 12,
        goalsAgainst: 10,
    },
    {
        id: 5,
        position: 5,
        teamName: "FPM 237",
        teamLogo: "/images/teams/default-team.png",
        points: 11,
        played: 8,
        won: 3,
        drawn: 2,
        lost: 3,
        goalsFor: 10,
        goalsAgainst: 10,
    },
];